module.exports = {
	"ha": "bc",
	"id": 5.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99.78952907129703,
						"dataLabels": {
							"enabled": true,
							"format": "3793"
						}
					},
					{
						"y": 89.2396737700605,
						"dataLabels": {
							"enabled": true,
							"format": "3392"
						}
					},
					{
						"y": 83.97790055248619,
						"dataLabels": {
							"enabled": true,
							"format": "3192"
						}
					},
					{
						"y": 79.47908445146015,
						"dataLabels": {
							"enabled": true,
							"format": "3021"
						}
					},
					{
						"y": 63.246514075243354,
						"dataLabels": {
							"enabled": true,
							"format": "2404"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.49856733524355,
						"dataLabels": {
							"enabled": true,
							"format": "2778"
						}
					},
					{
						"y": 89.21919770773638,
						"dataLabels": {
							"enabled": true,
							"format": "2491"
						}
					},
					{
						"y": 84.06160458452722,
						"dataLabels": {
							"enabled": true,
							"format": "2347"
						}
					},
					{
						"y": 75.35816618911176,
						"dataLabels": {
							"enabled": true,
							"format": "2104"
						}
					},
					{
						"y": 50.78796561604585,
						"dataLabels": {
							"enabled": true,
							"format": "1418"
						}
					},
					{
						"y": null
					},
					{
						"y": 83.76841561126906,
						"dataLabels": {
							"enabled": true,
							"format": "3241"
						}
					},
					{
						"y": 57.40501421555958,
						"dataLabels": {
							"enabled": true,
							"format": "2221"
						}
					},
					{
						"y": 52.235719824243986,
						"dataLabels": {
							"enabled": true,
							"format": "2021"
						}
					},
					{
						"y": 49.26337554923753,
						"dataLabels": {
							"enabled": true,
							"format": "1906"
						}
					},
					{
						"y": 36.13336779529594,
						"dataLabels": {
							"enabled": true,
							"format": "1398"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -0.21047092870297712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.572106511995782,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.8962264150943415,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.35714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.423700761337304,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5014326647564515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.331173506119507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.780810919309509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.353642948444818,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.60456273764258,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -16.231584388730937,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.471767972847886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.004952723998194,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.690252350321623,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.652675760755507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=3801"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=2792"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3869"
			}
		],
		"dataTable": {
			"MSM": [
				3801,
				3793,
				3392,
				3192,
				3021,
				2404
			],
			"Non-MSM": [
				2792,
				2778,
				2491,
				2347,
				2104,
				1418
			],
			"Unknown": [
				3869,
				3241,
				2221,
				2021,
				1906,
				1398
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_4.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_4.json
// module id = 169
// module chunks = 0